import React from 'react';
import PropTypes from 'prop-types';
import './Container.scss';

const Container = ({ additionalClass, children, fullwidth, stick, side }) => (
  <div
    className={`w-container ${fullwidth ? 'w-container--fullwidth' : ''} ${
      stick ? 'w-container--stick' : ''
    } ${side ? `w-container--side-${side}` : ''} ${additionalClass}`}
  >
    {children}
  </div>
);

Container.defaultProps = {
  additionalClass: '',
  children: null,
  side: '',
};

Container.propTypes = {
  additionalClass: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  fullwidth: PropTypes.bool.isRequired,
  stick: PropTypes.bool.isRequired,
  side: PropTypes.string,
};

export default Container;
